import { useMemo } from 'react'
import { ScreenBreakpoints } from '../config/ScreenBreakpoints'
import { useWindowSize } from './useWindowSize'

export const useNumberOfPreviews = () => {
  const { width } = useWindowSize()
  return useMemo(() => {
    if (!!width && width > ScreenBreakpoints.breakpointMd) return 5
    return 4
  }, [width])
}
